<script>
  import FileUpload from "./FileUpload.svelte";
  import { budget } from "../stores.js";
  import { toast } from '@zerodevx/svelte-toast'

  let platforms = ["Android", "iPhone", "Web", "I'll Need Multiple Platforms"];

  let name = "";
  let selected = [];
  let platform = "";
  let selectedPlatform = '';
  let email = "";
  let about = "";
  let file;

  async function handleSubmit(event) {
    const payload = {
      name,
      platforms: selected,
      email,
      budget: $budget,
      productDescription: about
      // file
    };
    console.log(payload);
    const result = await fetch(`${__myapp.env.CWS_API_URL}/saveContact`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...payload,
      })
    });
    toast.push("Thanks, we'll contact you soon!")
    const content = await result.json();

    console.log(content);
  }
</script>

<style>
  .center {
    text-align: center;
  }
  .bold {
    font-weight: bold;
  }
  .white {
    color: #ffffff;
    font-family: "Montserrat", sans-serif;
  }
  .size-24 {
    font-size: 24;
  }
  .btn.btn-primary {
    color: #00bfff;
    background-color: white;
    border-color: white;
    box-shadow: 0 2px 2px 0 rgba(92, 92, 255, 0.432),
      0 3px 1px -2px rgba(100, 97, 255, 0.2),
      0 1px 5px 0 rgba(76, 73, 255, 0.12);
  }
  .btn.btn-primary:hover {
    background-color: #eaf7ff;
    color: #00bfff;
    border-color: white;
    box-shadow: 0 2px 2px 0 rgba(92, 92, 255, 0.432),
      0 3px 1px -2px rgba(100, 97, 255, 0.2),
      0 1px 5px 0 rgba(76, 73, 255, 0.12);
  }
  input {
    color: white;
    background-color: rgba(0, 0, 0, 0);
    border-top: 0;
    border-left: 0;
    border-right: 0;
  }
  ::placeholder {
    color: white;
  }
  select {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    color: white;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0);
  }
  select:active {
    color: white;
  }
  option {
    background-color: #55adf2;
  }
  .form-control,
  .is-focused .form-control {
    color: white;
    background-image: linear-gradient(
        to top,
        #76dbfd 2px,
        rgba(156, 39, 176, 0) 2px
      ),
      linear-gradient(to top, #d2d2d2 1px, rgba(210, 210, 210, 0) 1px);
  }
  .white-bg {
    background-color: white;
  }
  .primary-bg {
    background-color: #00bfff;
  }
  .primary-text {
    color: #00bfff;
    font-family: "Montserrat", sans-serif;
  }
  .no-margin {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .page-header {
    height: 20vh !important;
  }
</style>

<div class="white-bg">
  <h1 class="center primary-text bold no-margin anim">Contact Us</h1>
  <div class="white primary-bg">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="bold">Interested in a website or mobile app?</h1>
          <div class="size-24">
            Building things is hard. Code World Solution is your technology
            partner for all of your business challenges. We do websites, mobile,
            analytics to give you results.
          </div>
        </div>
        <div class="col">
          <div
            class="form-group <!-- removing the below breaks the whole form -->
            <!-- i do not understand bootstrap --> is-focused is-filled">
            <label for="name-input" />
            <input
              id="name-input"
              class="form-control"
              bind:value={name}
              placeholder="Your name"
              formControl="name" />
          </div>

            <p>Select your platform(s)</p>
            <select
              bind:value={selected}>
              {#each platforms as p}
                <option value={p}>{p}</option>
              {/each}
            </select>


          <div class="form-group">
            <input
              class="form-control"
              bind:value={email}
              placeholder="Your e-mail" />
          </div>

          <div class="form-group">
            <label for="budget-input" style="color: #efefef">Budget</label>
            <input
              id="budget-input"
              class="form-control"
              bind:value={$budget}
              placeholder="Your budget (optional)" />
          </div>

          <div class="form-group">
            <input
              class="form-control"
              bind:value={about}
              placeholder="Tell us about your project" />
          </div>


          <div class="form-group">
            <button
              on:click|preventDefault={handleSubmit}
              class="btn btn-primary">
              Send message
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
